import {fromJS} from 'immutable'
import generalReducer from './general/reducer'
import audioReducer from './audio/reducer'

const initialState = fromJS({})
  .set('general', generalReducer(undefined, {type: '@@INIT'}))
  .set('audio', audioReducer(undefined, {type: '@@INIT'}))

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  const nextGeneral = generalReducer(state.get('general'), action)
  const nextAudio = audioReducer(state.get('audio'), action)

  if (nextGeneral === state.get('general') && nextAudio === state.get('audio')) {
    return state
  }

  return state
    .set('general', nextGeneral)
    .set('audio', nextAudio)
}
;
